import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiDefault from '../../Api/ApiDefault';
import ToastMsg from '../../Components/ToastMsg';
import { creators as DefaultActions } from '../../Reducers/Reporting/Default';

export function* getDefaultInfo() {
  try {
    const response = yield call(ApiDefault.getDefaultInfo);

    if (response.status === 200) {
      yield put(DefaultActions.defaultSuccess({ defaultInfo: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Default Info',
            text: response.message,
          },
        },
      );
      yield put(DefaultActions.defaultFailure(response.message));
    }
  } catch (e) {
    yield put(DefaultActions.defaultFailure(e));
  }
}
